import { $createHorizontalRuleNode, $isHorizontalRuleNode, INSERT_HORIZONTAL_RULE_COMMAND } from '@lexical/extension';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $insertNodeToNearestRoot, mergeRegister } from '@lexical/utils';
import {
  $createNodeSelection,
  $getNodeFromDOMNode,
  $getSelection,
  $isNodeSelection,
  $isRangeSelection,
  $setSelection,
  CLICK_COMMAND,
  COMMAND_PRIORITY_EDITOR,
  COMMAND_PRIORITY_LOW,
  isDOMNode,
} from 'lexical';
import { useEffect } from 'react';

/**
 * Inserts horizontal rules and makes them click-selectable (so Delete removes them).
 * Stand-in for `HorizontalRuleExtension`, which needs `LexicalExtensionComposer`.
 */
export const HorizontalRulePlugin = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(
    () =>
      mergeRegister(
        editor.registerCommand(
          INSERT_HORIZONTAL_RULE_COMMAND,
          () => {
            if (!$isRangeSelection($getSelection())) return false;
            $insertNodeToNearestRoot($createHorizontalRuleNode());
            return true;
          },
          COMMAND_PRIORITY_EDITOR,
        ),
        editor.registerCommand(
          CLICK_COMMAND,
          (event) => {
            if (!isDOMNode(event.target)) return false;
            const node = $getNodeFromDOMNode(event.target);
            if (!$isHorizontalRuleNode(node)) return false;

            // Shift-click extends an existing node selection, like the extension does
            const selection = $getSelection();
            const nodeSelection = event.shiftKey && $isNodeSelection(selection) ? selection : $createNodeSelection();
            if (node.isSelected()) nodeSelection.delete(node.getKey());
            else nodeSelection.add(node.getKey());
            $setSelection(nodeSelection);
            return true;
          },
          COMMAND_PRIORITY_LOW,
        ),
      ),
    [editor],
  );

  return null;
};
